// es-lint-disable-next-line no-unused-vars
import { useState } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { device, shadows } from '../../../utils/styled-component-mixins';
import useIsMounted from '../../custom-hooks/useIsMounted';

const StaticCardWrapperStyled = styled.div`
  --cta-translateX: -7.5rem;
  height: 100%;

  .static-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    ${shadows.cardShadow}
  }
  .static-card {
    .featured-card {
      &-content {
        background-image: linear-gradient(
            180.14deg,
            rgba(0, 0, 0, 0) 21.26%,
            rgba(0, 0, 0, 0.56) 47.64%,
            rgba(0, 0, 0, 0.7) 99.82%
          ),
          url('${(props) => props.thumbnail}');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        padding: 2.4rem 2.4rem 3.2rem 2.4rem;
        z-index: 100;

        @media ${device.desktop} {
          padding: 2.4rem 3.2rem 3.2rem 3.2rem;
        }

        .content-wrapper {
          overflow: hidden;
          width: calc(100% - 4.8rem);

          @media ${device.desktop} {
            width: calc(100% - 6.4rem);
          }

          .description {
            color: var(--white);
            transition: top 0.3s ease-in-out;

            & * {
              font-size: 1.4rem;
              line-height: 2.4rem;
            }
          }
        }

        .overflow-wrapper {
          overflow: hidden;
          position: relative;
          z-index: 100;

          .cta-wrapper {
            display: inline-flex;
          }
        }

        h3 {
          color: var(--white);
          font-size: 1.6rem;
          line-height: 2.4rem;
          position: relative;
          word-break: break-word;
          z-index: 200;

          @media ${device.desktop} {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }
        }
      }
    }
  }
  &.preload * {
    animation: none !important;
    transition: none !important;
  }

  .animation-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;

    .description {
      display: none;
    }

    @media ${device.desktop} {
      height: 100%;
      padding-top: calc(16rem - 3.2rem);
      overflow: hidden;
      padding-top: 0;

      &:after {
        background-color: var(--bdo-red);
        content: '';
        height: 110%;
        position: absolute;
        right: 200%;
        top: 0;
        transform: skewX(50deg);
        transition: all 0.3s ease-in;
        width: 375%;
        z-index: 1;
      }

      &.hover-in.mounted {
        animation: translate-right 0.3s forwards;

        &::after {
          animation: translate-right 0.3s forwards;
          background-color: var(--slate);
        }

        .cta-wrapper {
          transform: translateX(0);
        }

        .content-wrapper {
          position: absolute;
          top: 7rem;
          transform: none;
          transition: all 0.3s linear;
          z-index: 2;

          .description {
            display: block;
            height: auto;
            opacity: 1;
          }
        }
      }

      .cta-wrapper {
        transform: translateX(calc((100% - 2rem) * -1));
      }

      .content-wrapper {
        top: calc(100% - 8rem);
        transform: translateY(-100%);
        position: absolute;
        transition: all 0.3s linear;
      }
      &.hover-out.mounted {
        animation: translate-left 0.3s forwards;

        &::after {
          animation: translate-left 0.3s forwards;
        }

        .cta-wrapper {
          display: inline-flex;
          transform: translateX(calc((100% - 2rem) * -1));
        }

        .content-wrapper {
          top: calc(100% - 8rem);
          transform: translateY(-100%);
          position: absolute;
          transition: all 0.3s linear;

          .description {
            height: 0;
            opacity: 0;
          }
        }
      }
    }
  }

  .overflow-wrapper > .cta-wrapper {
    align-items: center;
    color: var(--white);
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.8rem;
    margin-top: 1rem;
    text-decoration: none;

    span:last-child {
      font-size: 3.2rem;
    }

    .cta-line {
      display: flex;
      align-items: center;
    }

    @media ${device.tablet} {
      transition: all 0.3s ease-in-out;

      span:first-child {
        transition: all 0.3s ease-in-out;
      }
    }
  }

  @keyframes translate-right {
    from {
      right: 210%;
    }

    to {
      right: -150%;
    }
  }

  @keyframes translate-left {
    from {
      right: -110%;
    }

    to {
      right: 210%;
    }
  }
`;

const StaticCard = (props) => {
  const { item } = props;
  const [hoverState, setHoverState] = useState(null);
  const isMounted = useIsMounted();

  return (
    <StaticCardWrapperStyled className="static-card-wrapper" thumbnail={item.thumbnail1}>
      <a
        href={item.externalUrl ? item.externalUrl : item.url}
        target={item.externalUrl ? '_blank' : props.urlTarget}
        aria-label={`Read more about ${item.pageTitle}`}
      >
        <div
          className="static-card"
          onMouseEnter={() => setHoverState('hover-in')}
          onMouseLeave={() => setHoverState('hover-out')}
        >
          <div className="featured-card-content">
            <div className={classNames('animation-wrapper', hoverState, { mounted: isMounted })}>
              <div className="content-wrapper">
                <h3>{item.pageTitle}</h3>
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
              <div className="overflow-wrapper">
                {item.ctaText && (
                  <div className="cta-wrapper">
                    <p className="cta-line">
                      <span>{item.ctaText}</span>
                      <span className="material-icons-round" aria-hidden="true">
                        chevron_right
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </a>
    </StaticCardWrapperStyled>
  );
};

StaticCard.defaultProps = {
  urlTarget: '_self'
};

export default StaticCard;
